import axios from 'axios';
import { from, of } from 'rxjs';
import * as qs from 'query-string';
import { catchError, map, first } from 'rxjs/operators';
import queryString from 'query-string';
import lodash from 'lodash';

const DEFAULT_FAILURE_MESSAGE = { response: 'failure', message: '' }; // default failure message.
const BASE_URL = `${ process.env.REACT_APP_AOE_SECURE_WITH_PATH }`;
const BASE_URL_API = `${ process.env.REACT_APP_AOE_SECURE_WITH_PATH }/api`;
const JOB_BASE_URL = `${ process.env.REACT_APP_AOE_SECURE_WITH_PATH }/job`;
const JOB_BASE_URL_NEW = `${ process.env.REACT_APP_AOE_SECURE_WITH_PATH }/api/job`;
const JOB_REPORT_BASE = `${ process.env.REACT_APP_AOE_SECURE_WITH_PATH }/report`;
const DE_MS_SECURE_BASE_URL = `${ process.env.REACT_APP_MS_DIRECT_EMPLOYER_SECURE }`;


export const fetchJobList = (queryString) => {
   return from(axios.get(`${ JOB_BASE_URL_NEW }/filter?${ queryString }`)).pipe(
      map((response) => response.data),
      catchError((err) => { return of({ total: 0, jobs: [] }); }),
   );
};

export const getJobTitleSuggestions = (jobTitle) => {
   if (!jobTitle) {
      return of({});
   }
   let queryObj = {};
   queryObj["keywords"] = jobTitle;
   queryObj["maxSuggestions"] = 10;
   queryObj["minSuggestions"] = 5;
   return from(
      axios.get(`${ JOB_BASE_URL }/titleAutoSuggest?${ qs.stringify(queryObj) }`),
   ).pipe(
      map((response) => { return response.data; }),
      catchError((err) => { console.log(err); return of({ suggestions: [] }); }),
   );
};

export const getTemplateSuggestions = (queryObj) => {
   const queryString = qs.stringify(queryObj);
   return from(
      axios.get(`${ JOB_BASE_URL }/getTemplateTitles?${ queryString }`),
   ).pipe(
      map((response) => { return response.data; }),
      catchError((err) => { console.log(err); return of({ templates: [] }); }),
   );
};

export const getTemplateDescription = (id) => {
   if (!id) {
      return of({});
   }
   return from(
      axios.get(`${ JOB_BASE_URL }/getTemplateDescription?id=${ id }`),
   ).pipe(
      map((response) => { return response.data; }),
      catchError((err) => { console.log(err); return of({ template: {} }); }),
   );
};

/* Method to bulk publish jobs */
export const postBulkPublish = (queryObject) => {
   if (!queryObject) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Job publish failed.' });
   }
   return from(
      axios.get(`${ JOB_BASE_URL_NEW }/bulk/publish?${ queryString.stringify(queryObject) }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return { ...DEFAULT_FAILURE_MESSAGE, message: 'Jobs not published.' };
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Failed to publish jobs. Please try again.' }); }),
   );
};

/* Method to publish job */
export const postJobPublish = (queryObject) => {
   if (!queryObject) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Job publish failed.' });
   }
   return from(
      axios.get(`${ JOB_BASE_URL_NEW }/publish?jobId=${ queryObject }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return { ...DEFAULT_FAILURE_MESSAGE, message: 'Job not published.' };
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Failed to publish job. Please try again.' }); }),
   );
};

/* Method to bulk unpublish jobs */
export const postBulkUnpublish = (queryObject) => {
   if (!queryObject) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Job unpublish failed.' });
   }
   return from(
      axios.get(`${ JOB_BASE_URL_NEW }/bulk/unpublish?${ queryString.stringify(queryObject) }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return { ...DEFAULT_FAILURE_MESSAGE, message: 'Jobs not unpublished.' };
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Failed to unpublish jobs. Please try again.' }); }),
   );
};

/* Method to unpublish job */
export const postJobUnpublish = (queryObject) => {
   if (!queryObject) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Job unpublish failed.' });
   }
   return from(
      axios.get(`${ JOB_BASE_URL_NEW }/unpublish?jobId=${ queryObject }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return { ...DEFAULT_FAILURE_MESSAGE, message: 'Job not unpublished.' };
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Failed to unpublish job. Please try again.' }); }),
   );
};

/* Method to bulk hide jobs */
export const postBulkHide = (queryObject) => {
   if (!queryObject) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Job hide failed.' });
   }
   return from(
      axios.post(`${ JOB_BASE_URL_NEW }/bulk/hide?${ queryString.stringify(queryObject) }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return { ...DEFAULT_FAILURE_MESSAGE, message: 'Hide jobs not successful.' };
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Failed to hide jobs. Please try again.' }); }),
   );
};

/* Method to bulk unhide jobs */
export const postBulkUnhide = (queryObject) => {
   if (!queryObject) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Job unhide failed.' });
   }
   return from(
      axios.post(`${ JOB_BASE_URL_NEW }/bulk/unhide?${ queryString.stringify(queryObject) }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return { ...DEFAULT_FAILURE_MESSAGE, message: 'Unide jobs not successful.' };
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Failed to unhide jobs. Please try again.' }); }),
   );
};

/* Method to bulk forward jobs */
export const postBulkForward = (queryObject) => {
   if (!queryObject) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Job forward failed.' });
   }
   return from(
      axios.post(`${ JOB_BASE_URL_NEW }/bulk/forward?${ queryString.stringify(queryObject) }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return { ...DEFAULT_FAILURE_MESSAGE, message: 'Forward jobs not successful.' };
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Failed to forward jobs. Please try again.' }); }),
   );
};

/* Method to hide job from actions */
export const postJobHide = (queryObject) => {
   if (!queryObject) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Job hide failed.' });
   }
   return from(
      axios.post(`${ JOB_BASE_URL_NEW }/hide/${ queryObject }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return { ...DEFAULT_FAILURE_MESSAGE, message: 'Hiding job not successful.' };
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Failed to hide job. Please try again.' }); }),
   );
};

/* Method to fetch job log */
export const getJobLog = (queryObject) => {
   if (!queryObject) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Job log update failed.' });
   }
   return from(
      axios.post(`${ BASE_URL }/posting/getHistoryByJID?${ queryString.stringify(queryObject) }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return { ...DEFAULT_FAILURE_MESSAGE, message: 'Fetching job log not successful.' };
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Failed to get job log. Please try again.' }); }),
   );
};

/*
    Method to get Job Details.
    Takes in job id to get all details;
*/
export const getJobDetails = (jobId) => {
   if (!jobId) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Job id is required.' });
   }
   return from(
      axios.post(`${ JOB_BASE_URL_NEW }/getDetails/${ jobId }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data && response.data.job) {
            let data9 = response.data.job.data9;
            data9 = !!(data9 && data9.toUpperCase() === 'Y');
            let published = response.data.job.published;
            published = !!(published && published.toUpperCase() === 'Y');

            const resume_needed = response.data.job.resume_needed && response.data.job.resume_needed === 'y';

            return ({
               ...response.data.job,
               data9,
               published,
               resume_needed,
            });
         } else {
            return { ...DEFAULT_FAILURE_MESSAGE, message: 'Error getting job detail.' };
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Error getting job detail.' }); }),
   );
};

/*
    Method to get available contacts
    using the company Id.
*/
export const getAvailableJobContacts = (companyId) => {
   if (!companyId) {
      return of([]);
   }
   return from(
      axios.post(`${ JOB_BASE_URL_NEW }/getAvailableContacts?companyId=${ companyId }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data.map((item) => { return { ...item, ...{ label: item.text, id: +item.id } }; });
         } else {
            return [];
         }
      }),
      catchError((err) => { console.log(err); return of([]); }),
   );
};

/*
   get the contact users assigned for the job
*/
export const getJobContactUsers = (jobId) => {
   if (!jobId) {
      return of([]);
   }
   return from(
      axios.post(`${ JOB_BASE_URL_NEW }/getContactUsers/${ jobId }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return [];
         }
      }),
      catchError((err) => { console.log(err); return of([]); }),
   );
};

/*
   get contact emails for the job
*/
export const getJobContactEmails = (jobId) => {
   if (!jobId) {
      return of([]);
   }
   return from(
      axios.post(`${ JOB_BASE_URL_NEW }/getContactEmails/${ jobId }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return [];
         }
      }),
      catchError((err) => { console.log(err); return of([]); }),
   );
};

/* Method to update editorial status */
export const postJobEditorialStatus = (queryObject) => {
   if (!queryObject) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Job editorial status update failed.' });
   }
   return from(
      axios.get(`${ JOB_BASE_URL_NEW }/editorialStatus/${ queryObject }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         } else {
            return { ...DEFAULT_FAILURE_MESSAGE, message: 'Job editorial status not updated.' };
         }
      }),
      catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Failed to update job editorial status. Please try again.' }); }),
   );
};

const filterJobSaveFormData = (formData) => {
   let payload = lodash.cloneDeep(formData);
   let contactEmail = [];
   let contactUser = [];
   if (payload.jobCandidates) {
      const allUsers = payload.jobCandidates;
      const userLength = allUsers.length;
      for (let i = 0; i < userLength; i++) {
         const user = allUsers[i];
         if (user && user.label !== user.value && !isNaN(user.value)) {
            contactUser.push(user.value);
         } else {
            contactEmail.push(user.value);
         }
      }
   }
   let location = `${ payload.city ? payload.city + ', ' : '' }${ payload.state }${ payload.zip ? ' ' + payload.zip : '' }`;
   if (!payload.city && !payload.state && !payload.zip) {
      location = 'nationwide';
   } else if (!payload.city && payload.state) {
      location = `statewide ${  payload.state.toUpperCase()}`;
   }

   let finalObj = {
      address1: payload.address1 || '',
      city: payload.city,
      companyDescription: payload.companyDescription ? payload.companyDescription : '',
      contactEmail: '' + contactEmail.join(','),
      contactUser: '' + contactUser.join(','),
      contactUserMain: payload.contactUserMain,
      data9: payload.data9 ? 'y' : 'n',
      data10: payload.data9 ? payload.data10 : '',
      formId: payload.formId,
      id: payload.id,
      infoCompensation: '' + (payload.infoCompensation ? payload.infoCompensation : ''),
      infoCompensationMax: '' + (payload.infoCompensationMax ? payload.infoCompensationMax : ''),
      infoCompensationMin: '' + (payload.infoCompensationMin ? payload.infoCompensationMin : ''),
      infoCompensationType: payload.infoCompensationType,
      infoEmploymentType: payload.infoEmploymentType,
      jobCategoryId: payload.jobCategoryId || '21',
      jobDescription: payload.jobDescription,
      jobReferenceId: payload.jobReferenceId,
      externalUrl: payload.externalUrl || '',
      job_autopublish: payload.published ? 'Y' : 'N',
      latitude: payload.latitude,
      longitude: payload.longitude,
      location: location,
      publishMode: payload.publishMode,
      publish_cb: payload.published ? 'Y' : 'N',
      published: payload.published ? 'Y' : 'N',
      resume_needed: payload.resume_needed ? 'y' : 'n',
      state: payload.state,
      title: payload.title,
      trafficType2: payload.trafficType,
      upwardCampaignId: '' + (payload.jobGroup ? payload.jobGroup.id : payload.upwardCampaignId),
      validThrough: payload.validThrough ? payload.validThrough.replace(/\//gi, '-') : '',
      zip: payload.zip,
      data2: payload.data2,
   };
   if (payload.owner) {
      finalObj.owner = payload.owner;
   }
   return finalObj;
};

export const saveJob = (companyId, jobId, formData) => {
   const data = filterJobSaveFormData(formData);
   return from(
      axios.post(`${ JOB_BASE_URL_NEW }/save/${ companyId }/${ jobId }`, data),
   ).pipe(
      first(),
      map((response) => {
         return response && response.data ? response.data : {};
      }),
      catchError((err) => {
         console.log(err);
         return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Unable to save job. Please try again later.' });
      }),
   );
};

export const createJob = (companyId, formData) => {
   const data = filterJobSaveFormData(formData);

   return from(
      axios.post(`${ JOB_BASE_URL_NEW }/create/${ companyId }`, data),
   ).pipe(
      first(),
      map((response) => {
         return response && response.data ? response.data : {};
      }),
      catchError((err) => {
         console.log(err);
         return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'Unable to save job. Please try again later.' });
      }),
   );
};

export const findCandidates = (jobId, formData) => {
   const params = [];
   if (formData.radius) { params.push(`radius=${ formData.radius }`); }
   if (formData.size) { params.push(`size=${ formData.size }`); }
   if (formData.days) { params.push(`days=${ formData.days }`); }
   if (formData.candidateList) {
      for (let i = 0; i < formData.candidateList.length; i++) {
         params.push(`query=${ formData.candidateList[i].value }`);
      }
   }
   return from(
      axios.get(`${ JOB_BASE_URL_NEW }/findCandidates/${ jobId }?hl=b&${ params.join('&') }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data && response.data.data) {
            return { candidates: [...response.data.data], query: [...response.data.query], totalCandidates: response.data.total, searchType: response.data.searchType };
         }
         return { ...DEFAULT_FAILURE_MESSAGE, message: 'We could not find matching candidates for the job. Please try again later.' };
      }),
      catchError((err) => {
         console.log(err);
         return of({ candidates: [] });
      }),
   );
};

export const pickCandidates = (jobId, picked, unpicked) => {
   if (!jobId) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'We could not find matching candidates for the job. Please try again later.' });
   }

   if (!picked && !unpicked) {
      return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'We could not find matching candidates for the job. Please try again later.' });
   }
   return from(
      axios.get(`${ JOB_BASE_URL_NEW }/pickCandidates/${ jobId }?picked=${ picked }&unpicked=${ unpicked }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         }
         return { ...DEFAULT_FAILURE_MESSAGE, message: 'We could not find matching candidates for the job. Please try again later.' };
      }),
      catchError((err) => {
         console.log(err);
         return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'We could not find matching candidates for the job. Please try again later.' });
      }),
   );
};

// @TODO remove defaults!!!!!!!!!!!!!!
export const fetchJobReport = (qs) => {
   return from(
      axios.get(`${ BASE_URL_API }/deReport/run?${ qs }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         }
         return { ...DEFAULT_FAILURE_MESSAGE, message: 'No report details found.' };
      }),
      catchError((err) => {
         console.log(err);
         return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'No report details found.' });
      }),
   );
};

export const exportJobReport = (qs) => {
   return from(
      axios({
         url: `${ BASE_URL_API }/deReport/export?${ qs }`,
         method: 'GET',
         responseType: 'blob',
      }),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         }
         return { ...DEFAULT_FAILURE_MESSAGE, message: 'No report details found.' };
      }),
      catchError((err) => {
         console.log(err);
         return of({ ...DEFAULT_FAILURE_MESSAGE, message: 'no report details found.' });
      }),
   );
};

// http://stage.upward.net/empl/api/reportChart/run?companyId=&company=&end=2020-01-20&id=&name=&jobId=&jobTitle=&start=2020-01-01&ts=1580322937795
export const fetchJobReportGraph = (qs) => {
   return from(
      axios.get(`${ BASE_URL_API }/reportChart/run?${ qs.replace('fromDate', 'start').replace('endDate', 'end') }`),
   ).pipe(
      first(),
      map((response) => {
         if (response && response.data) {
            return response.data;
         }
         return { chartData: [] };
      }),
      catchError((err) => {
         console.log(err);
         return of({ chartData: [] });
      }),
   );
};

export const getPostbackHandlerListByOrganizationId = (organizationId) => {
   return axios.get(`${DE_MS_SECURE_BASE_URL}postback-handler/get?organizationId=${ organizationId }`);
};

